export const coBorrowersPathForOLA = 'ola:coBorrowers';
export const loanDetailsMockData = [
  { Make: 'FIAT', Model: '124 Spider', Year: 2019 },
  { Make: 'FIAT', Model: '124 Spider', Year: 2018 },
  { Make: 'FIAT', Model: '124 Spider', Year: 2017 },
  { Make: 'Ram', Model: '1500 Classic Crew Cab', Year: 2019 },
  { Make: 'Ram', Model: '1500 Classic Quad Cab', Year: 2019 },
  { Make: 'Ram', Model: '1500 Classic Regular Cab', Year: 2019 },
  { Make: 'GMC', Model: '1500 Club Coupe', Year: 1999 },
  { Make: 'GMC', Model: '1500 Club Coupe', Year: 1998 },
  { Make: 'GMC', Model: '1500 Club Coupe', Year: 1997 },
  { Make: 'GMC', Model: '1500 Club Coupe', Year: 1996 },
  { Make: 'GMC', Model: '1500 Club Coupe', Year: 1995 }
];
export const OLA_WelcomePage_Title = 'Online Loan Application';
export const OLA_SecuredLoan_Title = 'Secured Loan Application';
export const OLA_LoanDetails_SubTitle = 'Determine your financing options.';
export const OLA_LoanDetails_PLOC_SubTitle = 'Determine your loan purpose and credit limit.';

export const OLARoutingUrl = {
  LoanType: '/ola/ola-consumer-loan-type',
  Loandetails: '/ola/ola-loan-details',
  OlaEligibility: '/ola/eligibility',
  Auto: '/ola-consumer/auto/ola-consumer-loan-type',
  CreditCard: '/ola-consumer/cc/ola-consumer-loan-type',
  Personal: '/ola-consumer/personal/ola-consumer-loan-type',
  PersonalLineOfCredit: '/ola-consumer/personal-line-of-credit/ola-consumer-loan-type',
  Secured: '/ola-consumer/secured/ola-consumer-loan-type',
  UsedVehicle: '/ola-consumer/usedvehicle/ola-consumer-loan-type',
  NewVehicle: '/ola-consumer/newvehicle/ola-consumer-loan-type',
  BoatAndRV: '/ola-consumer/boatandrv/ola-consumer-loan-type',
  Motorcycle: '/ola-consumer/motorcycle/ola-consumer-loan-type',
  SignatureLoan: '/ola-consumer/signatureloan/ola-consumer-loan-type',
  HolidayLoan: '/ola-consumer/holidayloan/ola-consumer-loan-type',
  VacationLoan: '/ola-consumer/vacationloan/ola-consumer-loan-type',
  ApplianceLoan: '/ola-consumer/applianceloan/ola-consumer-loan-type'
};

export const OLAFlowId = {
  personalloan: 'ola-consumer/personal',
  creditcard: 'ola-consumer/cc',
  personallineofcredit: 'ola-consumer/personal-line-of-credit',
  secured: 'ola-consumer/secured',
  usedvehicle: 'ola-consumer/usedvehicle',
  signatureloan: 'ola-consumer/signatureloan',
  newvehicle: 'ola-consumer/newvehicle',
  boatandrv: 'ola-consumer/boatandrv',
  holidayloan: 'ola-consumer/holidayloan',
  vacationloan: 'ola-consumer/vacationloan',
  applianceloan: 'ola-consumer/applianceloan',
  motorcycle: 'ola-consumer/motorcycle'
};

export const PERSONALLOAN = 'personalloan';
export const CREDITCARD = 'creditcard';
export const PERSONALLINEOFCREDIT = 'personallineofcredit';
export const SECURED = 'secured';
export const USEDVEHICLE = 'usedvehicle';
export const SIGNATURELOAN = 'signatureloan';
export const NEWVEHICLE = 'newvehicle';
export const BOATANDRV = 'boatandrv';
export const HOLIDAYLOAN = 'holidayloan';
export const VACATIONLOAN = 'vacationloan';
export const APPLIANCELOAN = 'applianceloan';
export const MOTORCYCLE = 'motorcycle';

export const getOLAUrl = (selectedLoanType: string) => {
  let routingUrl = OLARoutingUrl.Auto;
  selectedLoanType = selectedLoanType.toLowerCase();
  switch (selectedLoanType) {
    case PERSONALLOAN:
      routingUrl = OLARoutingUrl.Personal;
      break;
    case CREDITCARD:
      routingUrl = OLARoutingUrl.CreditCard;
      break;
    case PERSONALLINEOFCREDIT:
      routingUrl = OLARoutingUrl.PersonalLineOfCredit;
      break;
    case SECURED:
      routingUrl = OLARoutingUrl.Secured;
      break;
    case USEDVEHICLE:
      routingUrl = OLARoutingUrl.UsedVehicle;
      break;
    case SIGNATURELOAN:
      routingUrl = OLARoutingUrl.SignatureLoan;
      break;
    case NEWVEHICLE:
      routingUrl = OLARoutingUrl.NewVehicle;
      break;
    case BOATANDRV:
      routingUrl = OLARoutingUrl.BoatAndRV;
      break;
    case HOLIDAYLOAN:
      routingUrl = OLARoutingUrl.HolidayLoan;
      break;
    case VACATIONLOAN:
      routingUrl = OLARoutingUrl.VacationLoan;
      break;
    case APPLIANCELOAN:
      routingUrl = OLARoutingUrl.ApplianceLoan;
      break;
    case MOTORCYCLE:
      routingUrl = OLARoutingUrl.Motorcycle;
      break;
  }
  return routingUrl;
};
export const getOLAFlowId = (selectedLoanType: string) => {
  selectedLoanType = selectedLoanType.toLowerCase();
  return OLAFlowId[selectedLoanType] ? OLAFlowId[selectedLoanType] : 'ola-consumer/auto';
};

export const OLAActions = {
  PurchaseAction: 'purchaseaction',
  RefinanceAction: 'refinanceaction',
  PersonalLoanAction: 'personalloanaction',
  SecuredLoanAction: 'securedloanaction',
  PersonalLineOfCredit: 'personallineofcredit',
  CreditCardAction: 'creditcardaction'
};

export const OLAUITemplates = {
  AutoPurchaseTemplate: 'autopurchasetemplate',
  AutoRefinanceTemplate: 'autorefinancetemplate',
  PersonalTemplate: 'personaltemplate',
  PersonalLineOfCreditTemplate: 'personallineofcredittemplate',
  SecuredLoanCardTemplate: 'securedloancardtemplate',
  CreditCardTemplate: 'creditcardtemplate',
  AutoSmartTemplate: 'autosmarttemplate'
};

export const OLAPrams = {
  LoanType: 'loantype',
  LoanTypeOption: 'loantypeoption'
};
